<template>
  <section class="panel">
    <div class="panel-header"><h1>注册用户</h1><div class="actions"><button class="danger" @click="clearAll">清空用户</button><button @click="loadUsers">刷新</button></div></div>
    <div class="filter-bar">
      <button v-for="tab in statusTabs" :key="tab.value" :class="['tab', { active: status === tab.value }]" @click="switchStatus(tab.value)">{{ tab.label }}<span class="count">{{ tab.count }}</span></button>
      <span class="hint">资料未完善的微信占位账号不计为注册用户，也不能在小程序发布任何内容</span>
    </div>
    <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    <p v-else-if="loading">加载中...</p>
    <table v-else>
      <thead><tr><th>头像</th><th>姓名</th><th>年龄</th><th>性别</th><th>手机号码</th><th>资料状态</th><th>注册时间</th><th>操作</th></tr></thead>
      <tbody>
        <tr v-for="user in pagedUsers" :key="user.id">
          <td><img v-if="user.avatarUrl" :src="user.avatarUrl" alt="用户头像" class="avatar"><span v-else class="avatar avatar-ph">无</span></td>
          <td>{{ user.name }}</td>
          <td>{{ user.age ? user.age + ' 岁' : '-' }}</td>
          <td><span :class="['gender', user.gender === 'female' ? 'female' : 'male']">{{ user.gender === 'female' ? '♀ 女' : '♂ 男' }}</span></td>
          <td>{{ user.phone }}</td>
          <td><span :class="['profile', user.profileComplete ? 'ok' : 'warn']">{{ user.profileComplete ? '已完善' : '未完善' }}</span></td>
          <td>{{ formatDate(user.createdAt) }}</td>
          <td class="ops"><button class="mini" @click="openEdit(user)">编辑</button><button class="mini danger" @click="removeUser(user)">删除</button></td>
        </tr>
        <tr v-if="users.length === 0"><td colspan="8" class="empty">{{ emptyText }}</td></tr>
      </tbody>
    </table>
    <el-pagination v-if="!loading && !errorMessage" class="pagination" background layout="total, prev, pager, next" :total="total" :page-size="pageSize" :current-page.sync="page" @current-change="loadUsers" />

    <el-dialog title="编辑用户" :visible.sync="editVisible" width="460px" :close-on-click-modal="false">
      <div class="form">
        <div class="form-row"><label>头像预览</label><div class="avatar-edit"><img v-if="form.avatarUrl" :src="form.avatarUrl" class="avatar big"><span v-else class="avatar avatar-ph big">无</span></div></div>
        <div class="form-row"><label>头像地址</label><el-input v-model="form.avatarUrl" size="small" placeholder="留空则清除头像（用户可在小程序用微信头像重新设置）"/></div>
        <div class="form-row"><label>昵称</label><el-input v-model="form.name" size="small" maxlength="20" placeholder="1-20 个字"/></div>
        <div class="form-row"><label>手机号码</label><el-input v-model="form.phone" size="small" placeholder="手机号或 wx_ 开头的微信标识"/></div>
        <div class="form-row"><label>性别</label><el-radio-group v-model="form.gender" size="small"><el-radio label="male">男</el-radio><el-radio label="female">女</el-radio></el-radio-group></div>
        <div class="form-row"><label>年龄</label><el-input v-model="form.age" size="small" type="number" maxlength="3" placeholder="1-120，留空表示未填写"/></div>
      </div>
      <div slot="footer" class="dialog-footer"><el-button size="small" @click="editVisible=false">取消</el-button><el-button size="small" type="primary" :loading="saving" @click="saveEdit">保存</el-button></div>
    </el-dialog>
  </section>
</template>

<script>
import request from '@/api/request';

export default {
  data() { return { users: [], page: 1, pageSize: 20, total: 0, status: 'complete', incompleteCount: 0, totalCount: 0, loading: true, errorMessage: '', editVisible: false, saving: false, form: { id: 0, name: '', phone: '', gender: 'male', age: '', avatarUrl: '' } }; },
  computed: {
    pagedUsers() { return this.users; },
    statusTabs() {
      const complete = Math.max(this.totalCount - this.incompleteCount, 0);
      return [
        { value: 'complete', label: '已完善资料', count: complete },
        { value: 'incomplete', label: '资料未完善', count: this.incompleteCount },
        { value: 'all', label: '全部', count: this.totalCount }
      ];
    },
    emptyText() {
      if (this.status === 'complete') return '暂无资料完善的注册用户';
      if (this.status === 'incomplete') return '没有资料未完善的账号';
      return '暂无注册用户';
    }
  },
  created() { this.loadUsers(); },
  methods: {
    switchStatus(value) {
      if (this.status === value) return;
      this.status = value;
      this.page = 1;
      this.loadUsers();
    },
    async loadUsers() {
      this.loading = true;
      this.errorMessage = '';
      try {
        const result = await request.get('/users', { params: { status: this.status, page: this.page, pageSize: this.pageSize } });
        this.users = result.data.list;
        this.total = result.data.total;
        this.incompleteCount = result.data.incompleteCount || 0;
        this.totalCount = result.data.totalCount || 0;
      } catch (error) {
        this.errorMessage = error.response && error.response.data ? error.response.data.message : '无法加载用户列表';
        if (error.response && error.response.status === 401) this.$router.replace('/login');
      } finally { this.loading = false; }
    },
    openEdit(user) {
      this.form = { id: user.id, name: user.name || '', phone: user.phone || '', gender: user.gender === 'female' ? 'female' : 'male', age: user.age || '', avatarUrl: user.avatarUrl || '' };
      this.editVisible = true;
    },
    async saveEdit() {
      if (!this.form.name.trim()) return this.$message.warning('请填写昵称');
      if (!this.form.phone.trim()) return this.$message.warning('请填写手机号码');
      if (this.form.age !== '' && this.form.age !== null) {
        const age = Number(this.form.age);
        if (!Number.isInteger(age) || age < 1 || age > 120) return this.$message.warning('年龄需为 1-120 的整数');
      }
      this.saving = true;
      try {
        await request.put(`/users/${this.form.id}`, { name: this.form.name.trim(), phone: this.form.phone.trim(), gender: this.form.gender, age: this.form.age === '' ? null : Number(this.form.age), avatarUrl: this.form.avatarUrl.trim() });
        this.$message.success('保存成功');
        this.editVisible = false;
        this.loadUsers();
      } catch (error) {
        this.$message.error(error.response && error.response.data ? error.response.data.message : '保存失败');
      } finally { this.saving = false; }
    },
    removeUser(user) {
      this.$confirm(`确定删除用户「${user.name}」？其发布的商品、帖子、聊天记录等关联数据将一并删除，且不可恢复。`, '删除用户', { type: 'warning', confirmButtonText: '删除', cancelButtonText: '取消' })
        .then(async () => {
          try {
            const result = await request.delete(`/users/${user.id}`);
            this.$message.success(result.message || '已删除');
            this.loadUsers();
          } catch (error) {
            this.$message.error(error.response && error.response.data ? error.response.data.message : '删除失败');
          }
        }).catch(() => {});
    },
    clearAll() {
      this.$prompt('此操作将删除所有注册用户及其商品、帖子、聊天等全部数据，且不可恢复！如确认，请输入：清空用户', '清空全部用户', { type: 'warning', confirmButtonText: '确认清空', cancelButtonText: '取消', inputPlaceholder: '输入：清空用户', inputPattern: /^清空用户$/, inputErrorMessage: '请输入「清空用户」以确认' })
        .then(async () => {
          try {
            const result = await request.delete('/users');
            this.$message.success(result.message || '已清空');
            this.loadUsers();
          } catch (error) {
            this.$message.error(error.response && error.response.data ? error.response.data.message : '清空失败');
          }
        }).catch(() => {});
    },
    formatDate(value) { return value ? new Date(value).toLocaleString('zh-CN', { hour12: false }) : '-'; }
  }
};
</script>

<style scoped>
.panel { padding: 28px; background: #fff; border: 1px solid #e0e8e3; }
.panel-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
h1 { margin: 0; font-size: 22px; font-weight: 500; }
.actions { display: flex; gap: 10px; }
button { border: 0; padding: 8px 14px; color: #fff; background: #1f6f50; border-radius: 4px; cursor: pointer; }
button.danger { background: #d9534f; }
button.mini { padding: 4px 10px; font-size: 12px; background: #1f6f50; }
button.mini.danger { background: #d9534f; }
table { width: 100%; border-collapse: collapse; text-align: left; }
th, td { padding: 12px; border-bottom: 1px solid #e7eeea; font-size: 14px; }
th { color: #587066; font-weight: 500; background: #f6f9f7; }
.avatar { width: 40px; height: 40px; border-radius: 50%; object-fit: cover; vertical-align: middle; }
.avatar.big { width: 56px; height: 56px; }
.avatar-ph { display: inline-flex; align-items: center; justify-content: center; background: #e7ece9; color: #8b9790; font-size: 12px; }
.avatar-ph.big { font-size: 13px; }
.gender { display: inline-flex; align-items: center; padding: 3px 9px; border-radius: 12px; font-size: 13px; }
.gender.male { color: #4f78a7; background: #e7eff7; }
.gender.female { color: #bd667d; background: #f8e8ed; }
.ops { white-space: nowrap; }
.filter-bar { display: flex; align-items: center; gap: 8px; margin-bottom: 16px; }
.filter-bar .tab { padding: 7px 14px; border: 1px solid #dbe5df; border-radius: 4px; color: #587066; background: #fff; cursor: pointer; }
.filter-bar .tab.active { border-color: #1f6f50; color: #fff; background: #1f6f50; }
.filter-bar .count { margin-left: 6px; padding: 1px 7px; border-radius: 10px; background: rgba(0,0,0,.08); font-size: 12px; }
.filter-bar .tab.active .count { background: rgba(255,255,255,.24); }
.filter-bar .hint { margin-left: auto; color: #8b9790; font-size: 12px; }
.profile { display: inline-flex; padding: 3px 10px; border-radius: 12px; font-size: 13px; }
.profile.ok { color: #1f6f50; background: #e6f2ec; }
.profile.warn { color: #b87939; background: #fbf1e5; }
.ops button + button { margin-left: 8px; }
.empty { padding: 36px; text-align: center; color: #718079; }
.error { color: #c33; }
.pagination { margin-top: 20px; }
.form-row { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
.form-row label { flex-shrink: 0; width: 72px; color: #587066; font-size: 13px; }
.form-row .el-input, .form-row .el-radio-group { flex: 1; }
.dialog-footer { text-align: right; }
</style>
